import http from './http'

export default class Service {
  constructor ({host, axios, url}) {
    this.host = host
    this.axios = axios || http.getAxiosInstance(host)
    this.url = url
  }

  get (query) {
    return this.axios.get(this.url, {params: query})
  }

  count (query) {
    return this.axios.get(`${this.url}/count`, {params: query})
  }

  getOne (id, query) {
    return this.axios.get(`${this.url}/${id}`, {params: query})
  }

  getEvents (id) {
    return this.axios.get(`${this.url}/${id}/events`)
  }

  put (id, data) {
    return this.axios.put(`${this.url}/${id}`, data)
  }

  patch (id, data) {
    return this.axios.patch(`${this.url}/${id}`, data)
  }

  delete (id) {
    return this.axios.delete(`${this.url}/${id}`)
  }

  post (data) {
    return this.axios.post(`${this.url}`, data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/Service.js